import React, { useState, useContext } from 'react';
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Avatar,
  Dropdown,
  // Space,
  theme,
  Typography,
} from 'antd';
import {
  UserAddOutlined,
  MenuOutlined,
  DesktopOutlined,
  DashboardOutlined,
  ShoppingCartOutlined,
  UsergroupAddOutlined,
  BankOutlined,
  ShopOutlined,
  IdcardOutlined,
  LogoutOutlined,
  DownOutlined,
  SettingOutlined
  // UserOutlined,
  // CaretDownFilled
} from '@ant-design/icons';
import { Outlet, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import logo from '../assets/tclogo.png';
import { AuthContext } from '../contexts/AuthContext';

const { Header, Content, Footer, Sider } = Layout;

const activedKey = (currentPath) =>{
  switch (currentPath) {
    case '/admin/dashboard': return '1'
    case '/admin/orders': return '2'
    case '/admin/customers': return '3'
    case '/admin/products': return '40'
    case '/admin/categories': return '41'
    case '/admin/brands': return '42'
    case '/admin/vendors': return '5'
    case '/admin/transactions': return '60'
    case '/admin/warehouses': return '61'
    case '/admin/transactions/receive': return '62'
    case '/admin/transactions/transfer': return '63'
    case '/admin/employees': return '7'
    case '/admin/users': return '8'
    default: return null;
  }
}
const menus = [
  {
    key: '1',
    icon: <DashboardOutlined />,
    label: <Link to={`/admin/dashboard?start_date=${dayjs().toISOString()}&end_date=${dayjs().toISOString()}`}>รายงาน</Link>,
  },
  {
    key: '2',
    icon: <ShoppingCartOutlined />,
    label: <Link to={'/admin/orders?page=1&page_size=10'}>ขายสินค้า</Link>,
  },
  {
    key: '3',
    icon: <UsergroupAddOutlined />,
    label: <Link to={'/admin/customers'}>ลูกหนี้</Link>,
  },
  {
    key: '5',
    icon: <BankOutlined />,
    label: <Link to={'/admin/vendors'}>เจ้าหนี้</Link>,
  },
  {
    key: '4',
    icon: <DesktopOutlined />,
    label: 'จัดการสินค้า',
    children: [
      {
        key: '40',
        label: <Link to={'/admin/products'}>สต๊อคสินค้า</Link>,
      },
      {
        key: '41',
        label: <Link to={'/admin/categories'}>ประเภท</Link>,
      },
      {
        key: '42',
        label: <Link to={'/admin/brands'}>ยี่ห้อ</Link>,
      }
    ]
  },
  {
    key: '6',
    icon: <ShopOutlined />,
    label: 'จัดการคลังสินค้า',
    children: [
      {
        key: '60',
        label: <Link to={'/admin/transactions?page=1&page_size=10'}>รายการดำเนินงาน</Link>,
      },
      {
        key: '61',
        label: <Link to={'/admin/warehouses'}>คลังสินค้า</Link>,
      },
      {
        key: '62',
        label: <Link to={'/admin/transactions/receive'}>รับสินค้า</Link>,
      },
      {
        key: '63',
        label: <Link to={'/admin/transactions/transfer'}>โอนสินค้า</Link>,
      },
    ]
  },
  {
    key: '7',
    icon: <IdcardOutlined />,
    label: <Link to={'/admin/employees'}>พนักงาน</Link>,
  },
  {
    key: '8',
    icon: <UserAddOutlined />,
    label: <Link to={'/admin/users'}>บัญชีผู้ใช้งาน</Link>,
  }
]

function AdminLayout() {

  const { user } = useContext(AuthContext);
  const userData = JSON.parse(user);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isBreakpoint, setIsBreakpoint] = useState(false);
  const {
    token: { colorBgContainer, sidbarBackground },
  } = theme.useToken();

  const onCollapse = (collapsed, type) => {
    setIsCollapsed(collapsed);
  };
  const onLogout = () => {
    localStorage.clear();
    window.location.replace('/');
  }
  // console.log(userData);
  // console.log(window.location.pathname);
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        breakpoint="lg"
        collapsedWidth="0"
        collapsed={isCollapsed}
        onCollapse={onCollapse}
        style={{
          background: sidbarBackground,
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 999
        }}
        onBreakpoint={(broken) => {
          setIsBreakpoint(broken);
        }}
      // onCollapse={(collapsed, type) => {
      //   console.log(collapsed, type);
      // }}
      >
        <Row justify='center' style={{ padding: '8px' }}>
          <Col>
            {/* <div className="demo-logo-vertical" /> */}
            <Avatar src={logo} size={72} style={{ background: '#FFF', padding: '4px' }} />
          </Col>
        </Row>
        <Menu
          // theme="dark"
          mode="inline"
          // defaultSelectedKeys={['4']}
          selectedKeys={activedKey(window.location.pathname)}
          items={menus}
          style={{
            background: sidbarBackground,
            color: "#FFF"
          }}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer, borderBottom: '2px solid #F0F0F0' }} >
          <Row justify="space-between">
            <Col>
              <Button
                type='text'
                icon={<MenuOutlined />}
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{ marginLeft: isCollapsed ? '16px' : '216px' }}
              />
            </Col>
            <Col style={{ marginRight: '16px' }}>
              {/* <Button
                type='text'
                icon={<LogoutOutlined />}
                onClick={onLogout}
              >
                ออกจากระบบ
              </Button> */}
              <Dropdown
                menu={{
                  items: [
                    {
                      key: '1',
                      label: (
                        <Button
                          type='text'
                          icon={<SettingOutlined />}
                          href='/admin/user/profile'
                        >
                          ข้อมูลส่วนตัว
                        </Button>
                      )
                    },
                    {
                      key: '2',
                      label: (
                        <Button
                          type='text'
                          icon={<LogoutOutlined />}
                          onClick={onLogout}
                        >
                          ออกจากระบบ
                        </Button>
                      ),
                    },
                  ]
                }}
              >
                <div>
                  <Avatar
                    style={{
                      background: '#ced8fb',
                      color: '#293c68',
                      fontWeight: 'bold',
                      marginRight: '8px'
                    }}
                  >
                    {userData.username.charAt(0).toUpperCase()}
                  </Avatar>
                  <Typography.Text style={{ margin: '0px', padding: '0px', marginRight: '8px' }}>

                    {userData.role}
                  </Typography.Text>
                  <DownOutlined />
                </div>

              </Dropdown>

            </Col>
          </Row>
        </Header>
        <Content
          style={{ margin: '16px', marginLeft: isBreakpoint ? '16px' : isCollapsed ? '16px' : '216px' }}

        >
          <div style={{ padding: 24, minHeight: 360, background: colorBgContainer }}>
            <Outlet />
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Thongchai it center</Footer>
      </Layout>
    </Layout>
  )
}

export default AdminLayout